import { render, staticRenderFns } from "./role-permission.vue?vue&type=template&id=f7ad1160&scoped=true"
import script from "./role-permission.vue?vue&type=script&lang=js"
export * from "./role-permission.vue?vue&type=script&lang=js"
import style0 from "./role-permission.vue?vue&type=style&index=0&id=f7ad1160&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7ad1160",
  null
  
)

export default component.exports